import React, { useState, useEffect } from 'react';
import {
  BackgroundContainer,
  Container,
  ErrorMessage,
  Loader,
} from '@app/components/error-pages/error-page-component';
import { Icon } from '@app/components';

export default function ErrorPage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <BackgroundContainer>
      <Container>
        {loading ? (
          <Loader>
            <Icon name="loader" />
          </Loader>
        ) : (
          <ErrorMessage>You don't have access to this page</ErrorMessage>
        )}
      </Container>
    </BackgroundContainer>
  );
}
